import { sendErrorToServices } from 'lib/logging';
import { useEffect } from 'react';

export function useQualityManagement(player: HTMLVideoElement | null) {
  useEffect(() => {
    if (!player) return;

    // Get the HLS instance
    const hls = (player as any).hlsPlayer;
    if (!hls) return;

    // Set to auto quality initially
    hls.currentLevel = -1;

    // Monitor buffer health
    const checkBufferHealth = () => {
      if (!hls.media) return;

      const bufferLen =
        hls.media.buffered.length > 0
          ? hls.media.buffered.end(hls.media.buffered.length - 1) -
            hls.media.currentTime
          : 0;

      // If buffer is critically low and we're not at lowest quality, switch down
      if (bufferLen < 2 && hls.currentLevel > 0) {
        const newLevel = Math.max(0, hls.currentLevel - 1);
        hls.currentLevel = newLevel;
        sendErrorToServices(
          'Video Quality',
          `Switched to lower quality due to low buffer: ${newLevel}`
        );
      }
    };

    // Check buffer health every second
    const bufferInterval = setInterval(checkBufferHealth, 1000);

    // Set up error handling
    const handleError = () => {
      const middleQuality = Math.floor(hls.levels.length / 2);
      hls.currentLevel = middleQuality;
      sendErrorToServices(
        'Video Quality',
        `Switched to manual quality level: ${middleQuality}`
      );
    };

    // Handle buffer flushing
    const handleBufferFlushing = () => {
      if (hls.autoLevelEnabled) {
        const currentLevel = hls.loadLevel;
        hls.currentLevel = currentLevel;
      }
    };

    // Add event listeners
    hls.on('error', handleError);
    hls.on('hlsBufferFlushing', handleBufferFlushing);

    // Clean up everything on unmount
    return () => {
      clearInterval(bufferInterval);
      hls.off('error', handleError);
      hls.off('hlsBufferFlushing', handleBufferFlushing);
    };
  }, [player]);
}
